import { findClosestElementByClass } from "../helpers/dom/closest";
import { nextByClass } from "../helpers/dom/next";
import { toggleBox } from "../toggleBox/toggleBox";
import errors from "../../plugins/errors";
import cookies from "../../plugins/cookies";
import { COOKIE_GDPRC } from "../../shared/global/variables";

export class SendForm {
	constructor() {}
	initSend($root = document) {
		this.FormBtns = $root.querySelectorAll('[data-js="ajax-form"]');
		this.constraints = {};
		for (let i = 0; i < this.FormBtns.length; i++) {
			const Btn = this.FormBtns[i];
			const Form = findClosestElementByClass(Btn, "ajax-form");
			const transactionIdInput = Form.querySelector(
				"[name=datalayer_transactionId], [data-name=datalayer_transactionId]"
			);
			if (transactionIdInput) {
				let transactionIdValue = uuid.v1();
				transactionIdValue = transactionIdValue.replace(/-/gi, "");
				transactionIdInput.value = transactionIdValue;
			}
			const Inpts = Form.querySelectorAll("input");
			if (!Btn.bindedSendForm) {
				Btn.bindedSendForm = true;
				Btn.addEventListener("click", (e) => {
					e.preventDefault();
					this.handleFormSubmit(Form);
				});
				Btn.addEventListener("keydown", (e) => {
					// e.preventDefault();
					if (e.keyCode === 13) this.handleFormSubmit(Form);
				});
				for (let j = 0; j < Inpts.length; j++) {
					Inpts[j].addEventListener("keydown", (e) => {
						// e.preventDefault();
						if (e.keyCode === 13) this.handleFormSubmit(Form);
					});
				}
			}
		}
	}
	showSuccess(Form) {
		const formWrapper = findClosestElementByClass(Form, "form-wrapper");
		const formContent = formWrapper.querySelectorAll(".form__thankyou-hide");
		const formThankYou = formWrapper.querySelector(".form__thankyou");
		const errorMessage = formWrapper.querySelector(".error_message");
		const leadFormParam = Form.getAttribute("data-ga-param");
		const ZetaContactTag = Form.getAttribute("data-contact-tag");
		const widgetForm = Form.closest('[data-js="contact-widget-form"]');
		const captchaResponse = Form.querySelector('[name="g-recaptcha-response"]');
		const that = this;
		// console.log(formWrapper);
		let formdataObj;
		let ajaxOptions = {
			method: Form.getAttribute("data-method"),
			url: Form.getAttribute("data-url"),
		};
		if (Form.getAttribute("data-form-data") === "formdata") {
			// console.log("formdata");
			formdataObj = new FormData(Form);
			ajaxOptions.dataType = "json";
			ajaxOptions.contentType = false;
			ajaxOptions.processData = false;
		} else {
			// console.log('serialize');
			formdataObj = $(Form)
				.find("select, textarea:not(.g-recaptcha-response), input")
				.serialize();

			if (captchaResponse && captchaResponse.value) {
				formdataObj += "&captcha=" + captchaResponse.value;
			}
		}
		ajaxOptions.data = formdataObj;
		// console.log("formData", formdataObj);
		// 	for (var pair of formdataObj.entries()) {
		// 		console.log(pair[0]+ ', ' + pair[1]);
		// }

		window.vueApplication.showLoader = true;
		$.ajax(ajaxOptions)
			.done(function (msg) {
				if (msg.success === true) {
					if (!Form.hasAttribute("data-consent-withdrawal")) {
						const transactionId = Form.querySelector(
							"[name=datalayer_transactionId], [data-name=datalayer_transactionId]"
						);
						const pageId = Form.querySelector("[name=pageId], [data-name=pageId]");
						let event = "";
						if (pageId) {
							event = "vpv_" + pageId.value + "_typ";
						} else if (transactionId) {
							event = "vpv_" + transactionId.id + "_typ";
						}

						const datalayerObject = {
							event: event,
							userID: Form.querySelector(
								"[name=datalayer_userID], [data-name=datalayer_userID]"
							)
								? Form.querySelector(
										"[name=datalayer_userID], [data-name=datalayer_userID]"
								  ).value
								: "",
							userLogin: Form.querySelector(
								"[name=datalayer_userLogin], [data-name=datalayer_userLogin]"
							)
								? Form.querySelector(
										"[name=datalayer_userLogin], [data-name=datalayer_userLogin]"
								  ).value
								: "",
							pageType: Form.querySelector(
								"[name=datalayer_pageType], [data-name=datalayer_pageType]"
							)
								? Form.querySelector(
										"[name=datalayer_pageType], [data-name=datalayer_pageType]"
								  ).value
								: "",
							siteArea: Form.querySelector(
								"[name=datalayer_siteArea], [data-name=datalayer_siteArea]"
							)
								? Form.querySelector(
										"[name=datalayer_siteArea], [data-name=datalayer_siteArea]"
								  ).value
								: "",
							productName: Form.querySelector(
								"[name=datalayer_productName], [data-name=datalayer_productName]"
							)
								? Form.querySelector(
										"[name=datalayer_productName], [data-name=datalayer_productName]"
								  ).value
								: "",
							productGroup: Form.querySelector(
								"[name=datalayer_productGroup], [data-name=datalayer_productGroup]"
							)
								? Form.querySelector(
										"[name=datalayer_productGroup], [data-name=datalayer_productGroup]"
								  ).value
								: "",
							productCategory: Form.querySelector(
								"[name=datalayer_productCategory], [data-name=datalayer_productCategory]"
							)
								? Form.querySelector(
										"[name=datalayer_productCategory], [data-name=datalayer_productCategory]"
								  ).value
								: "",
							lpVersion: Form.querySelector(
								"[name=datalayer_lpVersion], [data-name=datalayer_lpVersion]"
							)
								? Form.querySelector(
										"[name=datalayer_lpVersion], [data-name=datalayer_lpVersion]"
								  ).value
								: "",
							transactionId: transactionId ? transactionId.value : "",
							transactionAffiliation: Form.querySelector(
								"[name=datalayer_transactionAffiliation], [data-name=datalayer_transactionAffiliation]"
							)
								? Form.querySelector(
										"[name=datalayer_transactionAffiliation], [data-name=datalayer_transactionAffiliation]"
								  ).value
								: "",
							transactionTotal: Form.querySelector(
								"[name=datalayer_transactionTotal], [data-name=datalayer_transactionTotal]"
							)
								? Form.querySelector(
										"[name=datalayer_transactionTotal], [data-name=datalayer_transactionTotal]"
								  ).value
								: "",
							sku: Form.querySelector(
								"[name=datalayer_sku], [data-name=datalayer_sku]"
							)
								? Form.querySelector("[name=datalayer_sku], [data-name=datalayer_sku]")
										.value
								: "",
							name: Form.querySelector(
								"[name=datalayer_name], [data-name=datalayer_name]"
							)
								? Form.querySelector(
										"[name=datalayer_name], [data-name=datalayer_name]"
								  ).value
								: "",
							category: Form.querySelector(
								"[name=datalayer_category], [data-name=datalayer_category]"
							)
								? Form.querySelector(
										"[name=datalayer_category], [data-name=datalayer_category]"
								  ).value
								: "",
							price: Form.querySelector(
								"[name=datalayer_price], [data-name=datalayer_price]"
							)
								? Form.querySelector(
										"[name=datalayer_price], [data-name=datalayer_price]"
								  ).value
								: "",
							quantity: Form.querySelector(
								"[name=datalayer_quantity], [data-name=datalayer_quantity]"
							)
								? Form.querySelector(
										"[name=datalayer_quantity], [data-name=datalayer_quantity]"
								  ).value
								: "",
						};
						if (window.dataLayer) {
							window.dataLayer.push(datalayerObject);
						}
					}
					if (
						Form.getAttribute("data-redirect") != "" &&
						Form.getAttribute("data-redirect") != null
					) {
						window.location.href = Form.getAttribute("data-redirect");
					} else {
						const telInput = Form.querySelector("[type=tel]");
						const telSpan = formThankYou.querySelector("[data-thankyou-tel]");
						if (telInput && telSpan) {
							telSpan.innerText = telInput.value;
						}
						formThankYou.classList.remove("is-hidden");
						formThankYou.setAttribute("tabindex", "0");
						formThankYou.focus();
						if (widgetForm) {
							widgetForm.classList.add("success");
						}
						for (let i = 0; i < formContent.length; i++) {
							formContent[i].classList.add("is-hidden");
						}

						formThankYou.scrollIntoView({
							block: "center",
							behavior: "smooth",
						});

						// const lp = document.querySelector('[data-js="lp"]'),
						// 	lpForm = document.querySelector('[data-js="lpForm"]');
						// if ($(formThankYou).offset()) {
						// 	if (lpForm) {
						// 		$("html, body")
						// 			.animate(
						// 				{
						// 					scrollTop: -$(formThankYou).offset().top,
						// 				},
						// 				0
						// 			)
						// 			.promise()
						// 			.then(function () {
						// 				// console.log("runs once!")
						// 			});
						// 	} else if (!lp) {
						// 		$("html, body")
						// 			.animate(
						// 				{
						// 					scrollTop: $(formThankYou).offset().top - $(window).height() * 0.3,
						// 				},
						// 				300
						// 			)
						// 			.promise()
						// 			.then(function () {
						// 				// console.log("runs once!")
						// 			});
						// 	}
						// }
					}
					// google analytics event
					if (leadFormParam) {
						dataLayer.push({
							event: "leadform",
							eventParam1: "success",
							eventParam2: leadFormParam,
						});
					}
					if (ZetaContactTag) {
						if (cookies.getCookie(COOKIE_GDPRC) == "1") {
							fetch(ZetaContactTag)
								.then((response) => response.json())
								.then((response) => {
									const script = document.createElement("script");
									script.type = response.type;
									script.async = response.async;
									if (response.text) {
										script.text = response.text;
									} else {
										script.src = response.src;
									}
									const el = document.getElementsByTagName("script")[0];
									el.parentNode.insertBefore(script, el);
								});
						}
					}
				} else {
					const leadRecaptcha = formWrapper.querySelector(".form-popupb2c__re");

					if (msg.lead_form_state === 4) {
						if (leadRecaptcha) {
							leadRecaptcha.classList.remove("hidden");
							leadRecaptcha.dataset.active = true;
						}
					} else {
						that.showErrorMsg(msg.ErrorCode, formWrapper);

						const withdrawalRecaptchaId = window.recaptcha_withdrawalform;
						const leadRecaptchaId = window.recaptcha_leadform;

						[withdrawalRecaptchaId, leadRecaptchaId].forEach((id) => {
							if (id != undefined && id != null) {
								grecaptcha.reset(id);
							}
						});

						// google analytics event
						if (leadFormParam) {
							dataLayer.push({
								event: "leadform",
								eventParam1: "fail",
								eventParam2: leadFormParam,
							});
						}
						// console.log(Object.keys(msg.errors));
						// for (let key in msg.errors) {
						// 	let value = msg.errors[key];
						// 	let input = document.querySelector('#' + key);
						// 	let message = nextByClass(input, 'messages');
						// 	console.log(input, message, message.parentElement);
						// 	message.innerHTML = '<p class="error">' + value + '</p>';
						// 	message.parentElement.classList.remove('has-success');
						// 	message.parentElement.classList.add('has-error');
						// }
					}
				}
				window.vueApplication.showLoader = false;
			})
			.fail(function (jqXHR, textStatus) {
				errorMessage.classList.remove("is-hidden");
				const withdrawalRecaptchaId = window.recaptcha_withdrawalform;
				const leadRecaptchaId = window.recaptcha_leadform;

				[withdrawalRecaptchaId, leadRecaptchaId].forEach((id) => {
					if (id != undefined && id != null) {
						grecaptcha.reset(id);
					}
				});

				console.log("Request failed: " + textStatus);
				window.vueApplication.showLoader = false;
				// google analytics event
				if (leadFormParam) {
					dataLayer.push({
						event: "leadform",
						eventParam1: "fail",
						eventParam2: leadFormParam,
					});
				}
			});
	}
	showErrorMsg(eCode, formWrapper) {
		const errorMessage = formWrapper.querySelector(".error_message");
		errors.showError(eCode, errorMessage);
		errorMessage.classList.remove("is-hidden");
	}
	handleFormSubmit(form, dontSend) {
		validate.validators.custom = function (value, options, key, attributes) {
			if (value !== null && value.length === 9) {
				// value = value.replace('+48 ', '');
				var n = 0;
				var z = 0;
				var e1 = 0;
				var e2 = 0;
				var e3 = 0;
				var f = 0;
				var t1 = 0;
				var t2 = 0;
				var t3 = 0;
				var val = value[0];
				val = parseInt(val);
				var val2 = value[3];
				val2 = parseInt(val2);
				var val3 = value[6];
				val3 = parseInt(val3);

				for (var i = 0; i < value.length; i++) {
					// sprawdzenie czy wszytkie liczby sa takie same
					if (val == parseInt(value[i])) {
						n++;
					}
					// sprawdzenie czy     6 ostatnich cyfr to zera
					if (i > 2 && parseInt(value[i]) == 0) {
						z++;
					}
					// sprawdzenie 8 pierwszych czy takie same
					if (n == 8 && i == 8) {
						return options;
					}
					// sprawdzenie po 3 te same liczby
					if (val == parseInt(value[i]) && i < 3) {
						e1++;
					} else if (val2 == parseInt(value[i]) && i > 2 && i < 6) {
						e2++;
					} else if (val3 == parseInt(value[i]) && i > 5) {
						e3++;
					}
					// sprawdzenie dwa pierwsze zera
					if (parseInt(value[i]) == 0 && i < 2) {
						f++;
					}
					// sprawdzenie 100100100
					if (parseInt(value[i]) == 0 && i > 0 && i < 3) {
						t1++;
					} else if (parseInt(value[i]) == 0 && i > 3 && i < 6) {
						t2++;
					} else if (parseInt(value[i]) == 0 && i > 6) {
						t3++;
					}
				}
				if (n == value.length) {
					return options;
				}
				if (z >= 6) {
					return options;
				}
				if (
					e1 == 3 &&
					e2 == 3 &&
					e3 == 3 &&
					val != val2 &&
					val != val3 &&
					val2 != val3
				) {
					return options;
				}
				if (f == 2) {
					return options;
				}
				if (t1 == 2 && t2 == 2 && t3 == 2 && val == val2 && val2 == val3) {
					return options;
				}
			}
			// return true;
		};
		validate.validators.file_validation = function (
			value,
			options,
			key,
			attributes
		) {
			// console.log('value', value, 'options', options, 'key', key, 'attributes', attributes);

			var oInput = form.querySelector('[name="' + key + '"]');
			var _validFileExtensions = oInput.getAttribute("accept");
			_validFileExtensions = _validFileExtensions.split(",");
			// console.log('_validFileExtensions', _validFileExtensions);
			// console.log('oInput', oInput);
			if (oInput.type === "file") {
				var sFileName = oInput.value;
				// console.log('sFileName', sFileName);
				if (sFileName.length > 0) {
					var blnValid = false;
					for (var j = 0; j < _validFileExtensions.length; j++) {
						var sCurExtension = _validFileExtensions[j];
						if (
							sFileName
								.substr(sFileName.length - sCurExtension.length, sCurExtension.length)
								.toLowerCase() == sCurExtension.toLowerCase()
						) {
							blnValid = true;
							break;
						}
					}
					if (!blnValid) {
						return options;
					}
				}
			}
		};

		// consent withdrawal form
		if (form.hasAttribute("data-consent-withdrawal")) {
			const recaptcha = form.querySelector("#withdrawalform_recaptcha");
			const recaptchaId = window.recaptcha_withdrawalform;
			const recaptchaError = form.querySelector("#withdrawalform_recaptchaError");
			const groups = form.querySelectorAll("[data-consent-withdrawal-group]");
			var groupsCount = 0;
			this.constraints = {};
			var errors = {};

			if (recaptchaError.classList.contains("is-shown")) {
				recaptchaError.classList.remove("is-shown");
			}

			groups.forEach((group) => {
				const groupInputs = group.querySelectorAll("input");
				const groupError = group.querySelector(".group-error-message");
				const groupInputsRequired = group.querySelectorAll(
					"input[data-required-group]"
				);
				let filledInputs;

				if (!groupError.classList.contains("is-hidden")) {
					groupError.classList.add("is-hidden");
				}
				if (groupInputsRequired.length !== 0) {
					filledInputs = Array.from(groupInputsRequired).filter(function (input) {
						if (input.type == "checkbox") {
							return input.checked;
						} else if (input.type === "radio") {
							return input.checked;
						} else {
							return input.value !== "";
						}
					});
				} else {
					filledInputs = Array.from(groupInputs).filter(function (input) {
						if (input.type == "checkbox") {
							return input.checked;
						} else {
							return input.value !== "";
						}
					});
				}

				if (groupInputsRequired.length !== 0) {
					if (groupInputsRequired.length > filledInputs.length) {
						groupError.classList.remove("is-hidden");
					}
				} else if (!filledInputs.length) {
					groupError.classList.remove("is-hidden");
				}

				if (groupError.classList.contains("is-hidden")) {
					for (let i = 0; i < filledInputs.length; i++) {
						if (filledInputs[i].getAttribute("data-required") === "tel") {
							this.constraints[filledInputs[i].getAttribute("name")] = {
								presence: {
									message: function (
										value,
										attribute,
										validatorOptions,
										attributes,
										globalOptions
									) {
										return (
											"^" +
											form
												.querySelector('[name="' + attribute + '"]')
												.getAttribute("data-error-empty")
										);
									},
								},
								length: {
									minimum: 9,
									message: function (
										value,
										attribute,
										validatorOptions,
										attributes,
										globalOptions
									) {
										return (
											"^" +
											form
												.querySelector('[name="' + attribute + '"]')
												.getAttribute("data-error-length")
										);
									},
								},
								custom: function (
									value,
									attribute,
									validatorOptions,
									attributes,
									globalOptions
								) {
									return (
										"^" +
										form
											.querySelector('[name="' + validatorOptions + '"]')
											.getAttribute("data-error-invalid")
									);
								},
							};
						}
						if (filledInputs[i].getAttribute("data-required") === "email") {
							this.constraints[filledInputs[i].getAttribute("name")] = {
								presence: {
									message: function (
										value,
										attribute,
										validatorOptions,
										attributes,
										globalOptions
									) {
										return (
											"^" +
											form
												.querySelector('[name="' + attribute + '"]')
												.getAttribute("data-error-empty")
										);
									},
								},
								format: function (
									value,
									attributes,
									attributeName,
									options,
									constraints
								) {
									if (
										form
											.querySelector('[name="' + attributeName + '"]')
											.getAttribute("data-pattern")
									) {
										return {
											pattern: new RegExp(
												form
													.querySelector('[name="' + attributeName + '"]')
													.getAttribute("data-pattern")
											),
											message: function (
												value,
												attribute,
												validatorOptions,
												attributes,
												globalOptions
											) {
												return (
													"^" +
													form
														.querySelector('[name="' + attribute + '"]')
														.getAttribute("data-error-pattern")
												);
											},
										};
									}
								},
							};
						}
						if (
							filledInputs[i].getAttribute("data-required") === "text" ||
							(filledInputs[i].getAttribute("data-required") === "text_if" &&
								filledInputs[i].value !== "" &&
								filledInputs[i].value !== null)
						) {
							// console.log('val', filledInputs[i].value, filledInputs[i].getAttribute('name'));
							this.constraints[filledInputs[i].getAttribute("name")] = {
								presence: {
									message: function (
										value,
										attribute,
										validatorOptions,
										attributes,
										globalOptions
									) {
										return (
											"^" +
											form
												.querySelector('[name="' + attribute + '"]')
												.getAttribute("data-error-empty")
										);
									},
								},
								length: function (
									value,
									attributes,
									attributeName,
									options,
									constraints
								) {
									// console.log('length value', value, 'attributes', attributes, 'attributeName', attributeName, 'options', options, 'constraints', constraints);
									let minVal = Number(
										form
											.querySelector('[name="' + attributeName + '"]')
											.getAttribute("data-min-length")
									);
									// console.log('minVal', minVal, form.querySelector('[name="' + attributeName + '"]').getAttribute('data-min-length'));
									if (minVal < 1) {
										minVal = 3;
									}
									// console.log('minVal2', minVal);
									return {
										minimum: minVal,
										message: function (
											value,
											attribute,
											validatorOptions,
											attributes,
											globalOptions
										) {
											return (
												"^" +
												form
													.querySelector('[name="' + attribute + '"]')
													.getAttribute("data-error-length")
											);
										},
									};
								},
								format: function (
									value,
									attributes,
									attributeName,
									options,
									constraints
								) {
									if (
										form
											.querySelector('[name="' + attributeName + '"]')
											.getAttribute("data-pattern")
									) {
										return {
											pattern: new RegExp(
												form
													.querySelector('[name="' + attributeName + '"]')
													.getAttribute("data-pattern")
											),
											message: function (
												value,
												attribute,
												validatorOptions,
												attributes,
												globalOptions
											) {
												return (
													"^" +
													form
														.querySelector('[name="' + attribute + '"]')
														.getAttribute("data-error-pattern")
												);
											},
										};
									}
								},
							};
						}
						if (filledInputs[i].getAttribute("data-required") === "checkbox") {
							this.constraints[filledInputs[i].getAttribute("name")] = {
								inclusion: {
									within: [true],
									message: function (
										value,
										attribute,
										validatorOptions,
										attributes,
										globalOptions
									) {
										return (
											"^" +
											form
												.querySelector('[name="' + attribute + '"]')
												.getAttribute("data-error-empty")
										);
									},
								},
							};
						}
					}
					errors = validate(form, this.constraints);
					let validGroup = form.querySelectorAll("[data-valid-group]");
					let groupOk = false;

					if (errors) {
						for (let i = 0; i < validGroup.length; i++) {
							const elName = validGroup[i].name;
							if (!errors.hasOwnProperty(elName)) groupOk = true;
						}
						if (groupOk) {
							for (let i = 0; i < validGroup.length; i++) {
								const elName = validGroup[i].name;
								delete errors[elName];
							}
						}
					} else {
						groupsCount += 1;
					}
					this.showErrors(form, errors || {});
				}
			});

			if (dontSend) return errors;
			// check if at least one input in each group is valid
			if (groupsCount === groups.length) {
				if (this.isCaptchaChecked(recaptcha, recaptchaId)) {
					this.showSuccess(form);
				} else {
					recaptchaError.classList.add("is-shown");
				}
			}
		} else {
			const recaptchaWrapper = form.querySelector(".form-popupb2c__re");
			const recaptcha = form.querySelector("#leadform_recaptcha");
			let recaptchaId;
			let recaptchaError;

			if (recaptcha) {
				recaptchaId =
					window["leadform_recaptcha_" + recaptcha.getAttribute("data-form-id")];
				recaptchaError = form.querySelector("#leadform_recaptchaError");
				if (recaptchaError.classList.contains("is-shown")) {
					recaptchaError.classList.remove("is-shown");
				}
			}

			const inputs = form.querySelectorAll("[data-required]");
			this.constraints = {};

			for (let i = 0; i < inputs.length; i++) {
				if (inputs[i].getAttribute("data-required") === "checkbox") {
					this.constraints[inputs[i].getAttribute("name")] = {
						inclusion: {
							within: [true],
							message: function (
								value,
								attribute,
								validatorOptions,
								attributes,
								globalOptions
							) {
								return (
									"^" +
									form
										.querySelector('[name="' + attribute + '"]')
										.getAttribute("data-error-empty")
								);
							},
						},
					};
				}
				if (
					inputs[i].getAttribute("data-required") === "text" ||
					(inputs[i].getAttribute("data-required") === "text_if" &&
						inputs[i].value !== "" &&
						inputs[i].value !== null)
				) {
					// console.log('val', inputs[i].value, inputs[i].getAttribute('name'));
					this.constraints[inputs[i].getAttribute("name")] = {
						presence: {
							message: function (
								value,
								attribute,
								validatorOptions,
								attributes,
								globalOptions
							) {
								return (
									"^" +
									form
										.querySelector('[name="' + attribute + '"]')
										.getAttribute("data-error-empty")
								);
							},
						},
						length: function (
							value,
							attributes,
							attributeName,
							options,
							constraints
						) {
							// console.log('length value', value, 'attributes', attributes, 'attributeName', attributeName, 'options', options, 'constraints', constraints);
							let minVal = Number(
								form
									.querySelector('[name="' + attributeName + '"]')
									.getAttribute("data-min-length")
							);
							// console.log('minVal', minVal, form.querySelector('[name="' + attributeName + '"]').getAttribute('data-min-length'));
							if (minVal < 1) {
								minVal = 3;
							}
							// console.log('minVal2', minVal);
							return {
								minimum: minVal,
								message: function (
									value,
									attribute,
									validatorOptions,
									attributes,
									globalOptions
								) {
									return (
										"^" +
										form
											.querySelector('[name="' + attribute + '"]')
											.getAttribute("data-error-length")
									);
								},
							};
						},
						format: function (
							value,
							attributes,
							attributeName,
							options,
							constraints
						) {
							if (
								form
									.querySelector('[name="' + attributeName + '"]')
									.getAttribute("data-pattern")
							) {
								return {
									pattern: new RegExp(
										form
											.querySelector('[name="' + attributeName + '"]')
											.getAttribute("data-pattern")
									),
									message: function (
										value,
										attribute,
										validatorOptions,
										attributes,
										globalOptions
									) {
										return (
											"^" +
											form
												.querySelector('[name="' + attribute + '"]')
												.getAttribute("data-error-pattern")
										);
									},
								};
							}
						},
					};
				}
				if (inputs[i].getAttribute("data-required") === "email") {
					this.constraints[inputs[i].getAttribute("name")] = {
						presence: {
							message: function (
								value,
								attribute,
								validatorOptions,
								attributes,
								globalOptions
							) {
								return (
									"^" +
									form
										.querySelector('[name="' + attribute + '"]')
										.getAttribute("data-error-empty")
								);
							},
						},
						format: function (
							value,
							attributes,
							attributeName,
							options,
							constraints
						) {
							if (
								form
									.querySelector('[name="' + attributeName + '"]')
									.getAttribute("data-pattern")
							) {
								return {
									pattern: new RegExp(
										form
											.querySelector('[name="' + attributeName + '"]')
											.getAttribute("data-pattern")
									),
									message: function (
										value,
										attribute,
										validatorOptions,
										attributes,
										globalOptions
									) {
										return (
											"^" +
											form
												.querySelector('[name="' + attribute + '"]')
												.getAttribute("data-error-pattern")
										);
									},
								};
							}
						},
					};
				}
				if (inputs[i].getAttribute("data-required") === "tel") {
					this.constraints[inputs[i].getAttribute("name")] = {
						presence: {
							message: function (
								value,
								attribute,
								validatorOptions,
								attributes,
								globalOptions
							) {
								return (
									"^" +
									form
										.querySelector('[name="' + attribute + '"]')
										.getAttribute("data-error-empty")
								);
							},
						},
						length: {
							minimum: 9,
							message: function (
								value,
								attribute,
								validatorOptions,
								attributes,
								globalOptions
							) {
								return (
									"^" +
									form
										.querySelector('[name="' + attribute + '"]')
										.getAttribute("data-error-length")
								);
							},
						},
						custom: function (
							value,
							attribute,
							validatorOptions,
							attributes,
							globalOptions
						) {
							return (
								"^" +
								form
									.querySelector('[name="' + validatorOptions + '"]')
									.getAttribute("data-error-invalid")
							);
						},
					};
				}
				if (inputs[i].getAttribute("data-required") === "textarea") {
					this.constraints[inputs[i].getAttribute("name")] = {
						presence: {
							message: function (
								value,
								attribute,
								validatorOptions,
								attributes,
								globalOptions
							) {
								return (
									"^" +
									form
										.querySelector('[name="' + attribute + '"]')
										.getAttribute("data-error-empty")
								);
							},
						},
					};
				}
				if (inputs[i].getAttribute("data-required") === "radio") {
					this.constraints[inputs[i].getAttribute("name")] = {
						presence: {
							message: function (
								value,
								attribute,
								validatorOptions,
								attributes,
								globalOptions
							) {
								return (
									"^" +
									form
										.querySelector('[name="' + attribute + '"]')
										.getAttribute("data-error-empty")
								);
							},
						},
					};
				}
				if (inputs[i].getAttribute("data-required") === "file") {
					this.constraints[inputs[i].getAttribute("name")] = {
						presence: {
							message: function (
								value,
								attribute,
								validatorOptions,
								attributes,
								globalOptions
							) {
								return (
									"^" +
									form
										.querySelector('[name="' + attribute + '"]')
										.getAttribute("data-error-empty")
								);
							},
						},
						file_validation: function (
							value,
							attribute,
							validatorOptions,
							attributes,
							globalOptions
						) {
							return (
								"^" +
								form
									.querySelector('[name="' + validatorOptions + '"]')
									.getAttribute("data-error-invalid")
							);
						},
					};
				}
			}
			let validGroup = form.querySelectorAll("[data-valid-group]");
			let groupOk = false;

			// validate the form aainst the constraints
			var errors = validate(form, this.constraints);

			if (errors) {
				for (let i = 0; i < validGroup.length; i++) {
					const elName = validGroup[i].name;
					// console.log(errors.hasOwnProperty(elName));
					if (!errors.hasOwnProperty(elName)) groupOk = true;
				}
				if (groupOk) {
					for (let i = 0; i < validGroup.length; i++) {
						const elName = validGroup[i].name;
						delete errors[elName];
					}
				}
			}

			// then we update the form to reflect the results
			this.showErrors(form, errors || {});
			// console.log("errors", errors);

			//check if required consent has errors
			var requiredFieldsCount = form.querySelectorAll(
				".contactApprovalsContent [data-required]"
			);
			if (errors) {
				Object.keys(errors).forEach((errorField) => {
					requiredFieldsCount.forEach((field) => {
						if (errorField == field.id) {
							this.openApprovals(form);
						}
					});
				});
			}

			if (dontSend) return errors;
			if (!errors || Object.keys(errors).length == 0) {
				if (recaptcha && recaptchaWrapper.dataset.active) {
					if (this.isCaptchaChecked(recaptcha, recaptchaId)) {
						this.showSuccess(form);
					} else {
						recaptchaError.classList.add("is-shown");
					}
				} else {
					this.showSuccess(form);
				}
			}
		}
	}

	// Updates the inputs with the validation errors
	showErrors(form, errors) {
		var that = this;

		// We loop through all the inputs and show the errors for that input
		$.each(
			form.querySelectorAll(
				'input[name]:not([type="hidden"]), select[name], textarea[name]:not(.g-recaptcha-response)'
			),
			function (index, input) {
				// Since the errors can be null if no errors were found we need to handle
				// that
				that.showErrorsForInput(input, errors && errors[input.name]);
			}
		);
		if (Object.keys(errors)[0]) {
			form.querySelector("[name=" + Object.keys(errors)[0] + "]").focus();
		}
	}
	openApprovals(form) {
		const contactAcceptances = form.querySelector(".contactAcceptances");
		const contactApprovalsContent = form.querySelector(
			".contactApprovalsContent"
		);

		if (
			contactApprovalsContent
				.querySelector(".form__checkbox")
				.classList.contains("has-error")
		) {
			if (
				contactApprovalsContent.parentNode ===
				contactAcceptances.parentNode.parentNode
			) {
				toggleBox.changeTargetTextByDataset(
					form.querySelector(".contactAcceptances"),
					"open"
				);
			}
			toggleBox.showHide(form.querySelector(".contactApprovalsContent"), "open");
		}
	}
	// Shows the errors for a specific input
	showErrorsForInput(input, errors) {
		var that = this;
		// This is the root of the input
		var formGroup = this.closestParent(input, "form-group");
		// Find where the error messages will be insert into
		var messages = formGroup.querySelector(".messages");
		// First we remove any old messages and resets the classes
		this.resetFormGroup(formGroup);
		// If we have errors
		if (errors) {
			// we first mark the group has having errors
			formGroup.classList.add("has-error");
			// then we append all the errors
			$.each(errors, function (index, error) {
				that.addError(messages, error);
			});
		} else {
			// otherwise we simply mark it as success
			formGroup.classList.add("has-success");
		}
	}
	// Recusively finds the closest parent that has the specified class
	closestParent(child, className) {
		if (!child || child === document) {
			return null;
		}
		if (child.classList.contains(className)) {
			return child;
		} else {
			return this.closestParent(child.parentNode, className);
		}
	}
	resetFormGroup(formGroup) {
		// Remove the success and error classes
		formGroup.classList.remove("has-error");
		formGroup.classList.remove("has-success");
		// and remove any old messages
		$.each(formGroup.querySelectorAll(".help-block.error"), function (index, el) {
			el.parentNode.removeChild(el);
		});
	}
	// Adds the specified error with the following markup
	// <p class="help-block error">[message]</p>
	addError(messages, error) {
		var block = document.createElement("p");
		block.classList.add("help-block");
		block.classList.add("error");
		block.innerText = error;
		messages.appendChild(block);
	}
	isCaptchaChecked(recaptcha, recaptchaID) {
		return recaptcha && grecaptcha.getResponse(recaptchaID).length !== 0;
	}
}

const sForm = new SendForm();
export { sForm };
